module.exports = __webpack_public_path__ + "img/step1.b8d93a6.png";